<template>
  <v-autocomplete
    v-model="localValue"
    :clearable="clearable && !$attrs.readonly && $attrs.readonly !== ''"
    v-bind="$attrs"
    :items="itemList"
    :loading="loading"
    no-filter
    :search-input.sync="match"
    @change="v => $emit('change', v)"
    @focus="e => e.target.click()"
    ref="field"
  >
    <template v-slot:selection="data">
      <v-chip
        color="white"
        :selected="data.selected"
        class="chip--select-multi"
        :close="$attrs.multiple"
        @input="removeItem(data.item)"
      >
        <v-avatar>
          <img :src="data.item.photo" />
        </v-avatar>
        {{ data.item.text }}
      </v-chip>
    </template>
    <template v-slot:item="data">
      <v-list-tile-avatar>
        <img :src="data.item.photo" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
        <v-list-tile-sub-title v-if="data.item.teams">
          <v-chip class="my-0" s small v-for="team of data.item.teams" :key="team._id">
            <!-- <v-avatar>
              <v-img :src="team.logo" />
            </v-avatar>-->
            {{ team.name }}
          </v-chip>
        </v-list-tile-sub-title>
        <v-list-tile-sub-title v-else-if="data.item.entities">
          <v-chip class="my-0" small v-for="entity of data.item.entities" :key="entity._id">
            <!-- <v-avatar>
              <v-img :src="entity.logo" />
            </v-avatar>-->
            {{ entity.name }}
          </v-chip>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'debounce'
export default {
  name: 'UserField',
  props: {
    value: {
      type: [String, Array],
      required: false,
      default: ''
    },
    entityId: {
      type: String,
      required: false,
      default: ''
    },
    teamId: {
      type: String,
      required: false,
      default: ''
    },
    typeRole: {
      type: [String, Array],
      required: false,
      default: ''
    },
    populateEntity: {
      type: Boolean,
      required: false,
      default: false
    },
    populateTeam: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      match: '',
      itemList: [],
      cacheList: [],
      loading: false,
      init: false
    }
  },
  created() {
    this.fetch = debounce(function() {
      if (this.$refs.field && this.value !== this.$refs.field.lazyValue) {
        this.$refs.field.lazyValue = this.value
      }

      let params = { set: false }

      // if (this.localValue && !Array.isArray(this.localValue)) {
      //   params._id = this.localValue
      // } else if (
      //   Array.isArray(this.localValue) &&
      //   this.localValue.length &&
      //   !this.init
      // ) {
      //   params._id = this.localValue
      // }
      if (this.entityId) params.entityId = this.entityId

      if (this.teamId) params.teamId = this.teamId
      if (this.typeRole) params.typeRole = this.typeRole
      if (this.populateEntity) params.populateEntity = this.populateEntity
      if (this.populateTeam) params.populateTeam = this.populateTeam

      if (this.match) params.match = this.match

      this.loading = true
      this.$store
        .dispatch('users/setInitSelect', params)
        .then(list => {
          this.itemList = []
          list.forEach(item => {
            this.itemList.push(item)
          })
          if (
            !Array.isArray(this.value) &&
            !this.itemList.some(item => item.value === this.value)
          )
            this.value = ''

          this.setCache()
        })
        .finally(_ => {
          this.loading = false
          this.init = true
        })
    }, 700)
    this.fetch()
  },
  watch: {
    value(val, oldVal) {
      // if (
      //   Array.isArray(val) &&
      //   val.length &&
      //   (!oldVal || (Array.isArray(oldVal) && !oldVal.length))
      // )
      //   this.init = false

      // this.fetch()

      this.nextTick(_ => {
        this.$refs.field.lazyValue = val
      })
    },
    match() {
      this.fetch()
    },
    entityId() {
      this.fetch()
    },
    teamId() {
      this.fetch()
    },
    typeRole() {
      this.fetch()
    }
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    fetch() {},
    setCache() {
      if (Array.isArray(this.localValue)) {
        this.localValue.forEach(v => {
          const isCached = this.cacheList.some(item => item.value === v)
          if (!isCached) {
            let item = this.itemList.find(item => item.value === v)
            if (item) {
              this.cacheList.push(item)
            }
          }
        })
        this.cacheList = this.cacheList.filter(item =>
          this.localValue.includes(item.value)
        )
        this.cacheList.forEach(cacheItem => {
          const inList = this.itemList.some(
            listItem => listItem.value === cacheItem.value
          )
          if (!inList) this.itemList.push(cacheItem)
        })
      }
    },
    checkValue() {
      if (
        this.value &&
        !Array.isArray(this.value) &&
        !this.itemList.some(item => item.value === this.value)
      ) {
        this.value = ''
      }
    },
    removeItem(item) {
      if (Array.isArray(this.localValue)) {
        const index = this.localValue.indexOf(item.value)
        if (index >= 0) this.localValue.splice(index, 1)
      } else this.localValue = ''
    }
  }
}
</script>